var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadedAsset)?_c('div',{style:('background-image: url(' + _vm.loadedAsset.url + ');')}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }